/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpFromBracket: {
  name: 'arrow-up-from-bracket';
  data: string;
} = {
  name: 'arrow-up-from-bracket',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.707 4.293a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L11 7.414V15a1 1 0 1 0 2 0V7.414l1.293 1.293a1 1 0 1 0 1.414-1.414l-3-3ZM6 17a1 1 0 1 0-2 0v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1a1 1 0 1 0-2 0v1H6v-1Z" fill="currentColor"/></svg>`,
};
